import React from 'react';

import {OBJECTS_CREATABLE_PERMISSION} from 'auth/PermissionConstants';
import AssayRunSchemaSelector from 'notebook/integrations/runs/AssayRunSchemaSelector';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import {RadioButtonSelector} from 'ui-library/inputs/RadioButtonGroup';
import Modal from 'ui-library/modals/Modal';

interface RunInsertModalProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onInsertAssayRunSchema: (assayRunSchema: any) => void;
  onRequestClose: () => void;
}
interface State {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  assayRunSchema: any;
}

/**
 * A React component that renders a modal for inserting a new assay run component.
 */
export default class RunInsertModal extends React.Component<RunInsertModalProps, State> {
  state: State = {
    assayRunSchema: null,
  };

  handleInsertClick: () => void = () => {
    const {assayRunSchema} = this.state;
    this.props.onInsertAssayRunSchema(assayRunSchema);
  };

  _handleAssayRunSchemaChange: (assayRunSchema: AssaySchema) => void = (assayRunSchema) => {
    this.setState({assayRunSchema});
  };

  render(): JSX.Element {
    return (
      <Modal
        title={`Insert ${MODEL_NAMES.run}`}
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.handleInsertClick}
        className="mediocre" // TableEditable's CSS is namespaced under mediocre
        buttons={[
          {
            text: 'Insert',
            submit: true,
            style: ButtonStyle.SECONDARY,
            disabled: this.state.assayRunSchema == null,
          },
        ]}
      >
        <AssayRunSchemaSelector
          selectedAssayRunSchema={this.state.assayRunSchema}
          onAssayRunSchemaChange={(runSchema) => {
            // runSchema will not be null because shouldShowNoSchemaOption if false
            this._handleAssayRunSchemaChange(runSchema!);
          }}
          requiredPermissions={[OBJECTS_CREATABLE_PERMISSION]}
        />
      </Modal>
    );
  }
}
